import './DatesRange.css';

import React from 'react';
import { generateClassName, toLocaleDateTime } from '../../../b2b-common/helpers';
import { ArrowForwardIos, Event } from '@mui/icons-material';
import { getIconWithTooltip } from '../helper';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const DatesRange = ({ startDate, endDate, className = null, showIcon = false, showLabel = false, showSeparator = true, SeparatorIcon = ArrowForwardIos }) => {
    const { t } = useB2BTranslation('b2b-plans');
    return (
        <div className={generateClassName('dates-range', '', className)}>
            <div className={generateClassName('dates-range', '-start', className)}>
                {showIcon &&
                    <div className={generateClassName('dates-range', '-icon', className)}>
                        {getIconWithTooltip(Event, {}, t('Start Date'))}
                    </div>
                }
                {showLabel &&
                    <div className={generateClassName('dates-range', '-label', className)}>
                        {t('Start Date:')}
                    </div>
                }
                <div className={generateClassName('dates-range', '-value', className)}>
                    {toLocaleDateTime(startDate)}
                </div>
            </div>
            {showSeparator &&
                <div className={generateClassName('dates-range', '-separator', className)}>
                    <SeparatorIcon />
                </div>
            }
            <div className={generateClassName('dates-range', '-end', className)}>
                {showIcon &&
                    <div className={generateClassName('dates-range', '-icon', className)}>
                        {getIconWithTooltip(Event, {}, t('End Date'))}
                    </div>
                }
                {showLabel &&
                    <div className={generateClassName('dates-range', '-label', className)}>
                        {t('End Date:')}
                    </div>
                }
                <div className={generateClassName('dates-range', '-value', className)}>
                    {toLocaleDateTime(endDate)}
                </div>
            </div>
        </div>
    );
};

export default DatesRange;